import { object } from 'valibot';

import { stringRequired } from './schema.utils';

export const SaveCurrentUserInfoSchema = () =>
  object({
    firstName: stringRequired(),
    lastName: stringRequired(),
    displayName: stringRequired(),
    timezone: stringRequired()
  });
